import { useMemo } from 'react';

import { useTaskFrameStore } from '@/store';

import TaskLayoutHeaderLabelingCountPanel from './TaskLayoutHeaderLabelingCountPanel';
import TaskLayoutHeaderNotStartedFrame from './TaskLayoutHeaderNotStartedFrame';

const TaskLayoutCenter = () => {
  const { currentFrame, isValidFrameDetail, isWorkState } = useTaskFrameStore();

  const isPrework = isWorkState('Prework');
  const isRejected = isWorkState('Reject');
  const isRunningAiAnnotation = useMemo(
    () => currentFrame?.operationType === 'AIAnnotation',
    [currentFrame?.operationType],
  );

  return !isValidFrameDetail() ? (
    <></>
  ) : (isPrework || isRejected) && !isRunningAiAnnotation ? (
    <TaskLayoutHeaderNotStartedFrame />
  ) : (
    <TaskLayoutHeaderLabelingCountPanel />
  );
};

export default TaskLayoutCenter;
